export const FLAG_GETTING_GENERAL_INCOMES = 'FLAG_GETTING_GENERAL_INCOMES';
export const GET_GENERAL_INCOMES = 'GET_GENERAL_INCOMES';
export const CLEAR_GENERAL_INCOMES = 'CLEAR_GENERAL_INCOMES';
export const GET_GENERAL_INCOME = 'GET_GENERAL_INCOME';
export const CLEAR_GENERAL_INCOME = 'CLEAR_GENERAL_INCOME';
export const FLAG_GENERAL_INCOME_ACTIVITY = 'FLAG_GENERAL_INCOME_ACTIVITY';
